import React, { useState } from 'react';

import { Button, Row } from 'react-bootstrap';

import { InputField } from '../blocks/edit_blocks';
import { PROJECT_PREFIX } from '../const';
import { useUser } from '../contexts/user';

function AuthScreen({ history }) {
    const { user, setUser } = useUser();

    const [pin, setPin] = useState('');
    const [qrImgUrl, setQrImgUrl] = useState('');
    const [qrCheckResult, setCheckResult] = useState('');

    const handleChangePin = (event) => {
        const newPin = event.currentTarget.value;

        setPin(newPin);
    };

    const getQrHandler = async () => {
        try {
            const res = await fetch('/admin_api/auth/otp/');
            const imageBlob = await res.blob();
            const imageObjectURL = URL.createObjectURL((imageBlob));

            setQrImgUrl(imageObjectURL);
        } catch (error) {
            console.error(error);
        }
    };

    const sendPin = async () => {
        try {
            const res = await fetch('/admin_api/auth/otp/', {
                method: 'POST',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ token: pin }),
            });

            const data = await res.blob();

            if (res.status !== 200) {
                setCheckResult(`ОШИБКА! ${data}`);
            } else {
                setCheckResult('ОК!');
                setUser({
                    ...(user || {}),
                    otp_passed: true,
                });
                history.push(`${PROJECT_PREFIX}/`);
            }
        } catch (error) {
            console.error(error);
        }
    };

    const handleFormSubmit = (event) => {
        event.preventDefault();

        sendPin();
    };

    return (
        <div className="container-fluid">
            {user?.qr_required ? (
                <Row className="flex-column justify-content-center mt-3">
                    <h5 align="center">Получить QR для OTP</h5>
                    <Row className="justify-content-center mt-2">
                        {qrImgUrl === '' ? (
                            <Button onClick={getQrHandler}>Получить</Button>
                        ) : (
                            <img src={qrImgUrl} alt="OTP QR" />
                        )}
                    </Row>
                    <Row className="mt-2 justify-content-center">
                        <ol>
                            <li>Для подключения скачайте приложение Google Authenticator в Google Play или App Store</li>
                            <li>При первом запуске выберите режим "Оффлайн" и нажмите на иконку "+"</li>
                            <li>Отсканируйте QR-код c помощью приложения</li>
                            <li>Полученный код введите в поле проверки ниже</li>
                        </ol>
                    </Row>
                </Row>
            ) : null}
            <Row className="flex-column justify-content-center mt-3">
                <h5 align="center">Проверить QR</h5>
                <div className="mt-2">
                    {qrCheckResult === '' ? (
                        <form onSubmit={handleFormSubmit}>
                            <Row className="justify-content-center">
                                <div>
                                    <InputField
                                        name="totp"
                                        label="Код из приложения аутентификатора"
                                        value={pin}
                                        placeholder="000000"
                                        onChange={handleChangePin}
                                        maxLength={6}
                                    />
                                </div>
                                <div className="row ml-2">
                                    <Button
                                        className="align-self-end"
                                        type="submit"
                                    >
                                        Отправить
                                    </Button>
                                </div>
                            </Row>
                        </form>
                    ) : (
                        <Row className="justify-content-center">{qrCheckResult}</Row>
                    )}
                </div>
            </Row>
        </div>
    );
}

export default AuthScreen;
